var _ellipse, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 5.5,
    rx: 9,
    ry: 3.5,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11C22.5 13.2091 18.4706 15 13.5 15C8.52944 15 4.5 13.2091 4.5 11",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16C4.5 18.2091 8.52944 20 13.5 20C14.5519 20 15.5617 19.9198 16.5 19.7724",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6V16.5M4.5 6V22.2162C4.5 24.3059 8.52944 26 13.5 26C15.3501 26 16.0699 25.9025 17.5 25.5",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.3526C16.5 16.6795 17.1528 16.1946 17.8052 16.3599C18.9723 16.6557 20.6949 17.0263 22 17.0263C23.3051 17.0263 25.0277 16.6557 26.1948 16.3599C26.8472 16.1946 27.5 16.6808 27.5 17.3539C27.5 18.2522 27.5 19.7321 27.5 22.1579C27.5 27.1189 23.1714 28.6625 22.1944 28.9478C22.0649 28.9856 21.9344 28.9884 21.8036 28.9557C20.8225 28.7107 16.5 27.337 16.5 22.1579C16.5 19.72 16.5 18.2445 16.5 17.3526Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureData);
export default __webpack_public_path__ + "static/media/secure-data.4e6f96f553de9bc6445728312d24abad.svg";
export { ForwardRef as ReactComponent };